import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, Confirm, ComPhoto, NoResult } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능: 내거래처 리스트 조회
 * 세부설명:
*/

export class RtiList extends Component {
    static displayName = RtiList.name;
    constructor(props) {
        super(props);
        this.state = {            
            TotalCount: 0,
            RetailList:[],
            Search_Text: "",
            Search_Type: "reg_dt",
            Title: "",
            Appr_Status: "",
            Union_Uid:""
        };
        this.Page_Number = 1;
        this.Page_Size = Big3Common.WebConfig.Page_Size;

        this.handleSearch_Change = this.handleSearch_Change.bind(this);
        this.handleConfirm_Clik = this.handleConfirm_Clik.bind(this);
        this.handelDtl_Click = this.handelDtl_Click.bind(this);
        this.handleDealHistory_Click = this.handleDealHistory_Click.bind(this);
        this.handleAdd_Click = this.handleAdd_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        if (this.props.ContentState !== undefined && this.props.ContentState !== null)
        {
            //자식 Component에서 다시 원래 검색값의 설정이 필요할때 
            Big3Common.setContentStateBind(this);
        }
        this.CallRtiListData();
    }
    
    async CallRtiListData(isAppend) {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Retail/MyRetail/GetMyRetailGrupAP',
                {
                    "search_text": this.state.Search_Text,
                    "search_type": this.state.Search_Type,
                    "page_number": this.Page_Number,
                    "page_size": this.Page_Size
                });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const RetailList = JSON.parse(Data.dataTable);
                const TotalCount = (this.Page_Size * this.Page_Number);
                if (isAppend) {
                    let RetailListPush = this.state.RetailList;
                    RetailList.map(list => RetailListPush.push(list));
                    this.setState({ RetailList: RetailListPush, TotalCount: TotalCount });
                }
                else {

                    this.setState({ RetailList: RetailList, TotalCount: TotalCount });
                }

            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallRtiListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handleAdd_Click(event) {
        this.Page_Number++;
        this.CallRtiListData(true);
        event.preventDefault();
    }
    Confirm_Alert(appr_status, union_uid) {
        //메모리 값만 변경함.
        this.setState({ Appr_Status: appr_status, Union_Uid: union_uid });
        Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
    }
    async handleConfirm_Clik() {

        let Status= this.state.Appr_Status === "AP" ? "CA" : "AP";
        let Title = this.state.Appr_Status === "AP" ? "거래정지 되었습니다." : "거래재개 되었습니다.";
        let union_uid = this.state.Union_Uid;
        try {
            let Data = await Big3Common.Post('api/Retail/MyRetail/SetRetailGrupConfirm',
                {
                    "appr_status": Status,
                    "union_uid": union_uid
                });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                Big3Common.ModalAlert(bootstrap, 'AlertBox');
                this.state.Title = Title;
                this.Page_Number = 1;
                this.CallRtiListData();
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("handleConfirm_Clik: ", e)
        }
        return false;
    }
    handelDtl_Click(event, union_uid) {        
        let StateCopy = Big3Common.WebStorage.StateStorage(this.state);
        StateCopy.Union_Uid = union_uid;
        this.props.RenderComponent('RtiDtlAp', StateCopy);
        event.preventDefault();
    }
    async handleSearch_Change(event) {

        let tagId = event.target.id;
        this.Page_Number = 1;
        if (tagId === "searchCombo") {
            let ComboVal = event.target.value;
            this.state.Search_Type = ComboVal;
            await this.CallRtiListData();
        }
        else if (tagId === "searchText") {
            let textVal = event.target.value;
            this.state.Search_Text = textVal;
            await this.CallRtiListData();
        }
        return false;
    }
    handleDealHistory_Click(event, union_uid) {
        let StateCopy = Big3Common.WebStorage.StateStorage(this.state);
        StateCopy.Union_Uid = union_uid;
        this.props.RenderComponent('DealHistory', StateCopy)
    }
    render() {
        const RtiListData = this.state.RetailList;
        
        return (
            <div>
                <div className="tap_box tap_box_v2">
                    <div className="n_tap">
                        <div className="alert_tap tap_on" >내 거래처</div>
                    </div>
                    <div className="n_tap">
                        <Link to="/Retail/RetailMgr/Index">
                            <div className="alert_tap">승인요청</div>
                        </Link>
                    </div>
                </div>
                <div className="container_box m_f_margin u_padding">
                    <div className="search_box">
                        <div className="search_input_box">
                            <input type="text" placeholder="소매명을 입력해주세요."
                                id="searchText"
                                className="form-control"
                                defaultValue={this.state.Search_Text}
                                onBlur={this.handleSearch_Change}
                            />
                            <div className="search_btn" onClick={this.handleSearch_Change}></div>
                        </div>
                        <div className="order_select_box">
                            <select onChange={this.handleSearch_Change} id="searchCombo" value={this.state.Search_Type} >
                                <option value="reg_dt">최근 등록순</option>
                                <option value="lastdel_dt">최근 거래순</option>
                                <option value="mon_trunover">거래액 높은순</option>
                                <option value="mon_ordnumber">거래횟수 많은순</option>
                            </select>
                            <div className="select_btn"></div>
                        </div>
                    </div>
                    {RtiListData.map(list =>
                        <div className="alert_content" key={list.union_uid}>
                            <div className="alert_img pointer" onClick={(e) => this.handelDtl_Click(e, list.union_uid)}>
                                <ComPhoto className="alert_img_in" Photo={list.retail_photo} />
                            </div>
                            <div className="alert_txt">
                                <div className="alert_title order_title pointer">{list.retail_area_nm === "" ? "" : `[${list.retail_area_nm}]`} {list.retail_org_name}</div>
                                <div className="product_name order_name">매장 거래액: {Big3Common.Util.Money(list.mon_trunover) }원</div>
                                <div className="product_name order_name">누적 주문수: {Big3Common.Util.Money(list.mon_ordnumber)}건</div>
                                <div className="order_btn or_btn1" onClick={(e) => { this.handleDealHistory_Click(e, list.union_uid) }}>거래내역</div>
                                <div className="order_btn or_btn2" onClick={() => this.Confirm_Alert(list.appr_status, list.union_uid) }>{list.appr_status === "AP" ? "거래중지" : "거래재개"}</div>
                            </div>
                        </div>
                    )}
                    {this.state.TotalCount === this.state.RetailList.length && this.state.TotalCount>0 ? <button type="button" className="btn_v btn_inactive" onClick={this.handleAdd_Click}>더보기</button> : ""}
                </div>
                <Alert
                    id="AlertBox"
                    title={this.state.Title}
                />
                <Confirm
                    id="ConfirmBox"
                    title={this.state.Appr_Status === "AP" ? "거래중지 안내" : "거래재개 안내"}
                    content={this.state.Appr_Status === "AP" ? "정말로 거래를 중지하시겠습니까? <br/>거래중지 시 상품이 노출되지 않을 수 있습니다." : "거래를 재개하시겠습니까?"}
                    ConfirmClick={this.handleConfirm_Clik}
                />
                <NoResult
                    Visible={this.state.RetailList.length === 0 ? true : false}
                    Top={"60%"}
                />
            </div>
        );
    }
}
